import { render } from "./Inscriptions.vue?vue&type=template&id=0ca8f918"
import script from "./Inscriptions.vue?vue&type=script&lang=js"
export * from "./Inscriptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__